import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { HttpApiService } from '../../../../shared/services/http-api.service';
import { AvailableHours } from '../interfaces/available-hours.model';
import { Clinic } from '../interfaces/clinic.model';
import { Dentist } from '../interfaces/dentist.model';
import { ScheduleResponse } from '../interfaces/schedule-reponse.model';
import { ScheduleRequest } from '../interfaces/schedule-request.model';
import { PublicScheduleType } from '../interfaces/type.model';
import { PublicService } from './public.service';

@Injectable({
  providedIn: 'root'
})
export class PublicApiService {

  private publicScheduleData: any;

  constructor(
    private httpClient: HttpClient,
    private httpApiService: HttpApiService,
    private publicService: PublicService
  ) {
    this.publicService.onPublicScheduleData
      .pipe(filter(x => !!x))
      .subscribe(data => {
        this.publicScheduleData = data;
      });
  }

  getClinics(): Observable<Clinic[]> {
    return this.httpClient.get<Clinic[]>(`${this.httpApiService.getBasePath()}/clinics`);
  }

  getTypes(): Observable<PublicScheduleType[]> {
    return this.httpClient.get<PublicScheduleType[]>(`${this.httpApiService.getBasePath()}/schedule_types`);
  }

  getDentistsByClinic(): Observable<Dentist[]> {
    return this.httpClient.get<Dentist[]>(
      `${this.httpApiService.getBasePath()}/clinics/${this.publicScheduleData.clinic?.id}/dentists`
    );
  }

  getAvailableHoursByDentist(start_date: string, end_date: string): 
    Observable<AvailableHours[]> {
    let params = new HttpParams();
    params = params.append('start_date', start_date);
    params = params.append('end_date', end_date);
    return this.httpClient.get<AvailableHours[]>(
      `${this.httpApiService.getBasePath()}/clinics/` + 
      `${this.publicScheduleData.clinic?.id}/dentists/` + 
      `${this.publicScheduleData.dentist?.id}/available_hours`,
      { params: params }
    )
  }

  postPublicSchedule(data: ScheduleRequest): Observable<ScheduleResponse> {
    return this.httpClient.post<ScheduleResponse>(
      `${this.httpApiService.getBasePath()}/schedules`, data
    );
  }

  postApiUser(clientKey: string) {
   return this.httpClient.post<any>(`https://ha661zxbx4.execute-api.us-east-1.amazonaws.com/auth/check`, {key: clientKey})
  }
}
